export default {
  alert: {
    alertMessage: 'Sentimentos, temas e tags podem não estar disponíveis nas publicações do TikTok. As páginas do TikTok continuam selecionáveis, mas esses filtros podem não retornar resultados.',
    linkText: 'Saiba mais na Central de Ajuda',
  },
};
